import { grey } from "@mui/material/colors";

export const styles = {
  textField: {
    backgroundColor: "white",
    "& .MuiInputBase-root": { backgroundColor: "white" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  },
  button: {
    textTransform: "none",
    whiteSpace: { xs: "wrap", md: "nowrap" },
    borderRadius: 4,
    color: grey[500],
  },
};
